module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/City-of-Angels.46520bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/City-of-Angels.jpg
// module id = Pofh
// module chunks = 0